import React, { useEffect, useState } from "react";
import { API } from "../lib/appCommon";
import { openSSE } from "../lib/sse";

// Was `new WebSocket(`${wsBase}/stream`)` — the backend has never had a
// WebSocket handler, so this rendered three empty sections forever. It now
// consumes GET /stream/market-intel (SSE), which streams the realtime
// scanner's output in exactly this shape. The old "Predictive Rotation"
// section had no producer anywhere and is gone.
//
// Opened through openSSE like every other gated stream: the first rewrite
// used a bare EventSource, which sends no cookies cross-origin — the
// user-gated stream answered 401 and the panel sat on "reconnecting".
export default function LiveMarketDashboard() {
  const [data, setData] = useState(null);
  const [status, setStatus] = useState("connecting");

  useEffect(() => {
    const conn = openSSE(`${API}/stream/market-intel`, {
      intel: (event) => {
        try {
          setData(JSON.parse(event.data));
          setStatus("live");
        } catch {}
      },
    }, {
      onStatus: (ok) => setStatus((prev) => (ok ? (prev === "live" ? "live" : "connected") : "reconnecting")),
    });
    return () => conn.close();
  }, []);

  const scan = data?.scan || {};
  const topTrades = scan.top_trades || [];
  const rotation = scan.sector_rotation || [];
  const sourceNote = data?.top_trades_source === "latest_scan" ? " (from the latest scan)" : "";

  return (
    <div style={{ padding: 20, background: "#050505", color: "white" }}>
      <h2>🔥 Live Market Intelligence <span style={{ fontSize: 12, opacity: 0.6 }}>· {status}</span></h2>

      <h3>Top Trades{sourceNote}</h3>
      {topTrades.length === 0 && <div style={{ opacity: 0.6 }}>{status === "live" ? "No qualifying setups right now." : "Waiting for data…"}</div>}
      {topTrades.map((t, i) => (
        <div key={`${t.symbol}-${i}`} style={{ padding: 10, borderBottom: "1px solid #222" }}>
          {t.symbol} | Score: {Number(t.composite_score || 0).toFixed(1)}{t.direction ? ` | ${t.direction}` : ""}
        </div>
      ))}

      <h3>📊 Sector Rotation (Live)</h3>
      {rotation.length === 0 && <div style={{ opacity: 0.6 }}>{status === "live" ? "No sector data yet." : "Waiting for data…"}</div>}
      {rotation.map((s, i) => (
        <div key={`${s.sector}-${i}`}>
          {s.sector} → {s.bias} ({Number(s.rotation_score || 0).toFixed(1)})
        </div>
      ))}
    </div>
  );
}
